<template>
    <div>
        <form @submit.prevent="submit" autocomplete="off">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6">
                                    <legend>{{ $t("componenttype.General") }}</legend>
                                    <div class="form-label-group">
                                        <input class="form-control" id="name" name="name"
                                               placeholder="Enter name"
                                               type="text"
                                               v-bind:class="[this.name.validated ? this.name.valid ? 'is-valid' : 'is-invalid' : '']"
                                               v-model="form.name"
                                               v-validate="'required'">
                                        <label for="name">{{ $t("componenttype.Name") }}*</label>
                                        <small class="form-text text-muted">
                                            Name of the component type, e.g. Flame arrestor
                                        </small>
                                        <div class="invalid-feedback">{{ errors.first('name') }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-label-group">
                                                <input class="form-control" id="interval_control"
                                                       name="interval_control"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.interval_control.validated ? this.interval_control.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.interval_control"
                                                       v-validate="'required'">
                                                <label for="interval_control">{{ $t("componenttype.IntervalControl")
                                                    }}*</label>
                                                <small class="form-text text-muted">
                                                    The number of months to recheck the component, e.g. 12 (1 year)
                                                </small>
                                                <div class="invalid-feedback">{{ errors.first('interval_control') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <legend>{{ $t("componenttype.MinMax") }}</legend>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.pollution")}}</label>
                                        </div>
                                        <div class="offset-4 col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_pollution_rate"
                                                       name="max_pollution_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_pollution_rate.validated ? this.max_pollution_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_pollution_rate"
                                                       v-validate="'required'">
                                                <label for="max_pollution_rate">{{
                                                    $t("component.Max")}}*</label>
                                                <div class="invalid-feedback">{{ errors.first('max_pollution_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.wear")}}</label>
                                        </div>
                                        <div class="offset-4 col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_wear_rate" name="max_wear_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_wear_rate.validated ? this.max_wear_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_wear_rate"
                                                       v-validate="'required'">
                                                <label for="max_wear_rate">{{ $t("component.Max")
                                                    }}*</label>
                                                <div class="invalid-feedback">{{ errors.first('max_wear_rate') }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.weight")}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="min_weight_rate" name="min_weight_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.min_weight_rate.validated ? this.min_weight_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.min_weight_rate">
                                                <label for="min_weight_rate">{{
                                                    $t("component.Min")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('min_weight_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_weight_rate" name="max_weight_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_weight_rate.validated ? this.max_weight_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_weight_rate">
                                                <label for="max_weight_rate">{{
                                                    $t("component.Max")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('max_weight_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.backpressure")}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="min_back_pressure_rate"
                                                       name="min_back_pressure_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.min_back_pressure_rate.validated ? this.min_back_pressure_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.min_back_pressure_rate">
                                                <label for="min_back_pressure_rate">{{
                                                    $t("component.Min")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('min_back_pressure_rate')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_back_pressure_rate"
                                                       name="max_back_pressure_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_back_pressure_rate.validated ? this.max_back_pressure_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_back_pressure_rate">
                                                <label for="max_back_pressure_rate">{{
                                                    $t("component.Max")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('max_back_pressure_rate')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.leakage")}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="min_leakage_rate"
                                                       name="min_leakage_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.min_leakage_rate.validated ? this.min_leakage_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.min_leakage_rate">
                                                <label for="min_leakage_rate">{{
                                                    $t("component.Min")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('min_leakage_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_leakage_rate"
                                                       name="max_leakage_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_leakage_rate.validated ? this.max_leakage_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_leakage_rate">
                                                <label for="max_leakage_rate">{{
                                                    $t("component.Max")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('max_leakage_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit">{{$t('global.Submit')}}</button>
                            <button @click="deleteType()" class="btn btn-neutral red ml-2" type="button"
                                    v-if="!isNew">
                                {{$t('global.Delete')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'

    export default {
        name: 'appCreate',
        data() {
            return {
                isNew: true,
                dispatchLink: 'SAVE_TYPE',
                error: '',
                checkbox: true,
                form: {
                    name: '',
                    interval_control: '',
                    max_pollution_rate: '',
                    max_wear_rate: '',
                    max_weight_rate: '',
                    min_weight_rate: '',
                    max_back_pressure_rate: '',
                    min_back_pressure_rate: '',
                    max_leakage_rate: '',
                    min_leakage_rate: ''
                }
            }
        },
        computed: {
            ...mapFields([
                'name',
                'interval_control',
                'max_pollution_rate',
                'max_wear_rate',
                'max_weight_rate',
                'min_weight_rate',
                'max_back_pressure_rate',
                'min_back_pressure_rate',
                'max_leakage_rate',
                'min_leakage_rate'
            ])
        },
        async mounted() {
            //Check create or update
            this.isNew = true;
            this.dispatchLink = 'SAVE_TYPE';
            if (this.$route.params.id) {
                this.isNew = false;
                this.dispatchLink = 'UPDATE_TYPE';

                let customer = await this.$store.dispatch('GET_TYPE', this.$route.params.id)
                this.form = customer
            }
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$store.dispatch(this.dispatchLink, this.form)
                            .then(() => {
                                this.$swal({
                                    title: this.$t('swal.logout.SuccessTitle'),
                                    text: this.$t('swal.logout.SuccessMsg'),
                                    type: "success",
                                    toast: true,
                                    showConfirmButton: false,
                                    position: 'top-end',
                                    timer: 1200
                                });
                                if (this.isNew) {
                                    //Form leegmaken
                                    this.form = {}
                                    this.$validator.reset()
                                }
                            })
                            .catch((error) => {
                                if (error.errors.name) {
                                    this.$validator.errors.add({
                                        field: 'name',
                                        msg: error.errors.name[0]
                                    })
                                    this.fieldsVee.name.valid = false
                                }
                            })
                    }
                })
            },
            deleteType() {
                //Confirmation dialog, are you sure?
                this.$swal({
                    title: this.$t('swal.general.Title'),
                    text: this.$t('swal.delete.Text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: this.$t('swal.general.CancelButtonText'),
                    confirmButtonText: this.$t('swal.delete.ConfirmButtonText')
                }).then(async (result) => {
                        //Sure? -> Delete
                        if (result.value) {

                            let resp = await this.$store.dispatch('DELETE_TYPE', this.$route.params.id)

                            //Success message
                            this.$swal({
                                title: this.$t('swal.delete.SuccessTitle'),
                                text: resp.message,
                                type: "success",
                                toast: true,
                                showConfirmButton: false,
                                position: 'top-end',
                                timer: 1200
                            });

                            //Terugsturen naar index
                            this.$router.push({name: 'measurementIndex'})
                        }
                    }
                )
            },
        }
    }
</script>
<style>
    .custom-range {
        width: 100%;
        height: 1.4rem;
        padding: 0;
        background-color: transparent;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
</style>
